import styled from 'styled-components';
import styleUtils from '../../../styles/style.utils';
import themedColor from '../../../styles/theme/themed-color';

const Container = styled.div`
  position: fixed;
  width: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background: rgba(255, 255, 255, 0.5);
`;

const RingsContainer = styled.div`
  display: inline-block;
  position: relative;
  width: ${styleUtils.px(80)};
  height: ${styleUtils.px(80)};
`;

const Ring = styled.div`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: ${styleUtils.px(64)};
  height: ${styleUtils.px(64)};
  margin: ${styleUtils.px(8)};
  border: ${styleUtils.px(4)} solid ${themedColor('TEXT_BLUE')};
  border-radius: 50%;
  animation: spin-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${themedColor('TEXT_BLUE')} transparent transparent transparent;

  &:nth-child(1) {
    animation-delay: -0.45s;
  }
  &:nth-child(2) {
    animation-delay: -0.3s;
  }
  &:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes spin-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const SpinnerComponents = { Container, RingsContainer, Ring };

export default SpinnerComponents;
